import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { Answer } from '../types';
import { bugsnagNotify } from 'utilities/bugsnag';

export default function AnswerResultIcon(answer: Answer) {
  const { icon, selfGradeValue, selfGradeMin, selfGradeMax } = answer;
  if (icon === 'system_graded_correct') {
    return <i className="fa correct-sprite" />;
  } else if (icon === 'system_graded_incorrect') {
    return <i className="fa incorrect-sprite" />;
  } else if (icon === 'self_grade_needed') {
    return (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="self-graded-incomplete-tooltip">
            Click on this answer to read our rubrics and grade yourself.
          </Tooltip>
        }>
        <i className="fa ungraded-sprite" />
      </OverlayTrigger>
    );
  } else if (icon === 'self_graded') {
    return (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="self-graded-complete-tooltip">
            Score ranges from {selfGradeMin} to {selfGradeMax}
          </Tooltip>
        }>
        <b>{selfGradeValue}</b>
      </OverlayTrigger>
    );
  } else if (icon === 'video') {
    return (
      <OverlayTrigger
        placement="right"
        overlay={<Tooltip id="video-clip-tooltip">This was a video clip.</Tooltip>}>
        <span>
          <FontAwesomeIcon icon="video-camera" />
        </span>
      </OverlayTrigger>
    );
  } else if (icon === 'question_passage') {
    return (
      <OverlayTrigger
        placement="right"
        overlay={<Tooltip id="question-passage-tooltip">This was a question passage.</Tooltip>}>
        <span>
          <FontAwesomeIcon icon="file-text" />
        </span>
      </OverlayTrigger>
    );
  } else if (icon === 'ungraded') {
    return <i className="fa ungraded-sprite" />;
  } else {
    bugsnagNotify('Unsupported icon result: ' + icon);
    return null;
  }
}
